module.exports = __webpack_public_path__ + "static/media/image-1@3x.a9f48960.png";